<template>
    <div>

        <!-- Preview -->
        
        <div class="row">
            <div class="col">

                <trax-ui-card-with-background class="trax-top-box" :background-image="form.background">
                    <h3 class="card-title mt-3">{{ form.title }}</h3>
                    <p class="card-description" v-html="form.text"></p>
                    <a :href="form.button_data" target="_blank" class="btn btn-round btn-default" 
                        v-if="form.button_enabled && form.button_label && form.button_data">

                            <i class="material-icons">{{ form.button_icon }}</i>
                            {{ form.button_label }}
                    </a>
                    <p class="mt-4 mb-0" v-if="form.logo_enabled">
                        <img :src="app_url+form.logo_image">
                    </p>
                </trax-ui-card-with-background>

            </div>
        </div>

        <!-- Form -->
        
        <div class="row">
            <div class="col">

                <trax-ui-card>

                    <!-- Form -->

                    <form autocomplete="off" class="trax-form">
                        
                        <!-- Title -->

                        <trax-ui-input :placeholder="lang.polaris.common.setting_title" col="md-3"
                            v-model="form.title" :error="errors.title">
                        </trax-ui-input>

                        <!-- Text -->

                        <trax-ui-input :placeholder="lang.polaris.common.setting_html_text" :rows="7" col="md-3"
                            v-model="form.text" :error="errors.text">
                        </trax-ui-input>

                        <!-- Background -->

                        <trax-ui-select :placeholder="lang.polaris.common.setting_background_image" col="md-3"
                            v-model="form.background" :options="backgrounds_select">
                        </trax-ui-select>

                        <!-- Button enabled -->

                        <trax-ui-toggle :text="lang.polaris.common.setting_button_enabled" col="md-3" 
                            v-model="form.button_enabled">
                        </trax-ui-toggle>
                        
                        <!-- Button icon -->

                        <trax-ui-select :placeholder="lang.polaris.common.setting_button_icon" col="md-3"
                            v-model="form.button_icon" :options="button_icons_select" :unselected="lang.polaris.common.setting_no_icon"
                             v-show="form.button_enabled">
                        </trax-ui-select>

                        <!-- Button label -->

                        <trax-ui-input :placeholder="lang.polaris.common.setting_button_label" col="md-3"
                            v-model="form.button_label" :error="errors.button_label" v-show="form.button_enabled">
                        </trax-ui-input>

                        <!-- Button URL -->

                        <trax-ui-input :placeholder="lang.polaris.common.setting_button_url" col="md-3"
                            v-model="form.button_data" :error="errors.button_data" v-show="form.button_enabled">
                        </trax-ui-input>

                        <!-- Logo enabled -->

                        <trax-ui-toggle :text="lang.polaris.common.setting_logo_enabled" col="md-3" 
                            v-model="form.logo_enabled">
                        </trax-ui-toggle>
                        
                        <!-- Actions -->

                        <div class="trax-form-actions text-right">

                            <button type="button" class="btn btn-round btn-primary" @click="save"> 
                                {{ lang.polaris.form.save }} 
                            </button>

                        </div>
                    </form>

                    <!-- Toastr -->

                    <trax-ui-toastr :id="id+'-toastr'" :bus="bus">
                    </trax-ui-toastr>

                    <!-- Confirm modal -->

                    <trax-ui-modal-confirm :id="id+'-modal'" :title="this.lang.polaris.form.confirmation" :bus="bus">
                        {{ lang.polaris.common.confirm_homepage_settings_q }}
                    </trax-ui-modal-confirm>

                </trax-ui-card>

            </div>
        </div>
    
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-custom-homepage-settings'},
        },

        data: function() {
            return {
                lang: lang,
                app_url: app_url,
                endpoint: app_url + "polaris/api/front/settings/homepage",
                backgrounds_select: data.backgrounds_select,
                button_icons_select: data.button_icons_select,
                settings: data.home_settings,
                form: {},
                errors: {},
                bus: this.$bus
            }
        },

        created: function() {
            this.bus.$on(this.id+'-modal-confirmed', this.saveConfirmed);
        },

        mounted: function() {
            this.form = this.settings;
        },

        methods: {

            save() {
                this.bus.$emit(this.id+'-modal-open');
            },

            saveConfirmed() {
                this.errors = {};
                this.postData(this.form);
            },

            postData(data) {
                var that = this;
                axios.post(this.endpoint, data)
                    .then(function (response) {
                        that.bus.$emit(that.id+'-toastr-success');
                    })
                    .catch(function (error) {
                        if (error.response.data.errors) {
                            that.processErrors(error.response.data.errors);
                        } else {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data);
                        }
                    });
            },

            processErrors(errors) {
                for (var name in errors) {
                    var error = errors[name];
                    if (error instanceof Array) errors[name] = error[0];
                }
                this.errors = errors;
            }

        }
    }
</script>
